import React, { useState, useEffect } from "react";
import "./Quiz.css";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import Form from "./Form";
import Button from "@material-ui/core/Button";
import { Tooltip } from "@material-ui/core";
const Quiz = (props) => {
  const [q1, setq1] = useState(0);
  const [a1, seta1] = useState(0);
  const q1u = (e, data) => {
    setq1(data);
  };
  const optq1 = [
    { value: 0, label: "🚀" },
    { value: 1, label: "👍" },
    { value: 2, label: "🤔" },
    { value: 3, label: "✍" },
    { value: 4, label: "🚧" },
  ];
  const optq2 = [
    { value: 0, label: "🙅‍♂️" },
    { value: 1, label: "😕" },
    { value: 2, label: "😊" },
    { value: 3, label: "👍" },
    { value: 4, label: "💯" },
  ];
  const optq3 = [
    { value: 0, label: "😊" },
    { value: 1, label: "🙌" },
    { value: 2, label: "👍" },
    { value: 3, label: "👏" },
    { value: 4, label: "🎯" },
  ];
  const optq4 = [
    { value: 0, label: "🙅‍♂️" },
    { value: 1, label: "😕" },
    { value: 2, label: "😊" },
    { value: 3, label: "👍" },
    { value: 4, label: "💯" },
  ];
  const optq5 = [
    { value: 0, label: "🙅‍♂️" },
    { value: 1, label: "😕" },
    { value: 2, label: "😊" },
    { value: 3, label: "👍" },
    { value: 4, label: "💯" },
  ];
  const optq6 = [
    { value: 0, label: "🙅‍♂️" },
    { value: 1, label: "😕" },
    { value: 2, label: "😊" },
    { value: 3, label: "👍" },
    { value: 4, label: "💯" },
  ];
  const optq7 = [
    { value: 0, label: "🚫" },
    { value: 1, label: "🧐" },
    { value: 2, label: "🤔" },
    { value: 3, label: "👌" },
    { value: 4, label: "💯" },
  ];
  const optq8 = [
    { value: 0, label: "⏳" },
    { value: 1, label: "🐢" },
    { value: 2, label: "🤓" },
    { value: 3, label: "🏃‍♂️" },
    { value: 4, label: "🔥" },
  ];
  const optq9 = [
    { value: 0, label: "👎" },
    { value: 1, label: "🤯" },
    { value: 2, label: "😬" },
    { value: 3, label: "😍" },
    { value: 4, label: "👍" },
  ];
  const optq10 = [
    { value: 0, label: "🙅" },
    { value: 1, label: "🤔" },
    { value: 2, label: "😬" },
    { value: 3, label: "👍" },
    { value: 4, label: "💯" },
  ];
  const optq11 = [
    { value: 0, label: "📧" },
    { value: 1, label: "🚶‍♂️" },
    { value: 2, label: "😐" },
    { value: 3, label: "🏃‍♀️" },
    { value: 4, label: "🙋‍♂️" },
  ];
  const optq12 = [
    { value: 0, label: "🙅" },
    { value: 1, label: "🤔" },
    { value: 2, label: "😬" },
    { value: 3, label: "👍" },
    { value: 4, label: "💯" },
  ];
  const optq13 = [
    { value: 0, label: "🚧" },
    { value: 1, label: "🔎" },
    { value: 2, label: "😬" },
    { value: 3, label: "🔥" },
    { value: 4, label: "🌪" },
  ];
  useEffect(() => {
    seta1(q1);
  }, [q1]);

  const [q2, setq2] = useState(0);
  const [a2, seta2] = useState(0);
  const q2u = (e, data) => {
    setq2(data);
  };

  useEffect(() => {
    seta2(q2);
  }, [q2]);

  const [q3, setq3] = useState(0);
  const [a3, seta3] = useState(0);
  const q3u = (e, data) => {
    setq3(data);
  };

  useEffect(() => {
    seta3(q3);
  }, [q3]);

  const [q4, setq4] = useState(0);
  const [a4, seta4] = useState(0);
  const q4u = (e, data) => {
    setq4(data);
  };

  useEffect(() => {
    seta4(q4);
  }, [q4]);

  const [q5, setq5] = useState(0);
  const [a5, seta5] = useState(0);
  const q5u = (e, data) => {
    setq5(data);
  };

  useEffect(() => {
    seta5(q5);
  }, [q5]);

  const [q6, setq6] = useState(0);
  const [a6, seta6] = useState(0);
  const q6u = (e, data) => {
    setq6(data);
  };

  useEffect(() => {
    seta6(q6);
  }, [q6]);

  const [q7, setq7] = useState(0);
  const [a7, seta7] = useState(0);
  const q7u = (e, data) => {
    setq7(data);
  };

  useEffect(() => {
    seta7(q7);
  }, [q7]);

  const [q8, setq8] = useState(0);
  const [a8, seta8] = useState(0);
  const q8u = (e, data) => {
    setq8(data);
  };

  useEffect(() => {
    seta8(q8);
  }, [q8]);

  const [q9, setq9] = useState(0);
  const [a9, seta9] = useState(0);
  const q9u = (e, data) => {
    setq9(data);
  };

  useEffect(() => {
    seta9(q9);
  }, [q9]);
  const [q10, setq10] = useState(0);
  const [a10, seta10] = useState(0);
  const q10u = (e, data) => {
    setq10(data);
  };
  useEffect(() => {
    seta10(q10);
  }, [q10]);
  const [q11, setq11] = useState(0);
  const [a11, seta11] = useState(0);
  const q11u = (e, data) => {
    setq11(data);
  };
  useEffect(() => {
    seta11(q11);
  }, [q11]);
  const [q12, setq12] = useState(0);
  const [a12, seta12] = useState(0);
  const q12u = (e, data) => {
    setq12(data);
  };
  useEffect(() => {
    seta12(q12);
  }, [q12]);
  const [q13, setq13] = useState(0);
  const [a13, seta13] = useState(0);
  const q13u = (e, data) => {
    setq13(data);
  };
  useEffect(() => {
    seta13(q13);
  }, [q13]);

  const PrettoSlider1 = withStyles({
    root: {
      color: "blue",
      height: 8,
    },
    thumb: {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      marginTop: -8,
      marginLeft: -12,
      "&:focus, &:hover, &$active": {
        boxShadow: "inherit",
      },
    },
    valueLabel: {
      left: "calc(-50% + 4px)",
    },
    rail: {
      height: 8,
      borderRadius: 4,
    },
    track: {
      height: 8,
      borderRadius: 4,
    },
    markLabel: {
      fontSize: "25px",
      border: 0,
    },
  })(Slider);

  const ValueLabelComponent1 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"Make it live as soon as possible"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip
          placement="top"
          title={"Keep the changes for the next release"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Unsure, so may stall the release"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Implement some last minute changes"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip
          placement="top"
          title={
            "Push the release date by 2 weeks and include some BIG changes"
          }
        >
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent2 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"Strongly disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"Disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Neutral"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Agree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"Strongly agree"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent3 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"Happiness is most important"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"Happiness matters"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Both happiness and growth matter"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Growth matters"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"Growth is most important"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent4 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"Strongly disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"Disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Neutral"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Agree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"Strongly agree"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent5 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"Strongly disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"Disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Neutral"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Agree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"Strongly agree"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent6 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"Strongly disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"Disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Neutral"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Agree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"Strongly agree"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent7 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"Extremely unlikely"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"Somewhat unlikely"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Neutral"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Somewhat likely"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"Extremely likely"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent8 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip
          placement="top"
          title={"Taking your time and gradually learning as an approach"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"A medium paced cautious approach"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Taking calulative steps is wise"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"A fast paced cautious approach"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"Bold and pushy approach"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent9 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"It's all about the quality "}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip
          placement="top"
          title={"User inputs are more like suggestions "}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip
          placement="top"
          title={"We listen to users and have a strong hold on quality"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"We listen to our users"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"We give into our users needs easily"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent10 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip placement="top" title={"Strongly disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"Disagree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Neutral"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Agree"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip placement="top" title={"Strongly agree"}>
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent11 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip
          placement="top"
          title={
            "We prefer delegating duties and allow onwers to be accountable"
          }
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip
          placement="top"
          title={"Being personally accountable comes first"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip
          placement="top"
          title={
            "Leaders need lead from the front and also be the last one standing"
          }
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip
          placement="top"
          title={"It's more about allowing everyone to lead"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip
          placement="top"
          title={
            "We prefer owners to take charge since day one and be forthcoming in their leadership"
          }
        >
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent12 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip
          placement="top"
          title={"Structured silos are best for collaboration"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip placement="top" title={"Silos with some flexibility"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip
          placement="top"
          title={"Depending on the need, both are important"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip
          placement="top"
          title={"Some structured teams with lots of freedom"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip
          placement="top"
          title={"Unstructured teams are best for collaboration"}
        >
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const ValueLabelComponent13 = (props) => {
    const { children, value } = props;
    if (window.innerWidth > 550) {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
    if (value === 0) {
      return (
        <Tooltip
          placement="top"
          title={"Prefer to carefully delve into the unknown"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 1) {
      return (
        <Tooltip
          placement="top"
          title={"Only take on as much as we can handle"}
        >
          {children}
        </Tooltip>
      );
    } else if (value <= 2) {
      return (
        <Tooltip placement="top" title={"Luke warm towards curiosity"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 3) {
      return (
        <Tooltip placement="top" title={"Take on questions as they come"}>
          {children}
        </Tooltip>
      );
    } else if (value <= 4) {
      return (
        <Tooltip
          placement="top"
          title={"Prefer to constantly ask all the questions, now!"}
        >
          {children}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip placement="top" title={""}>
          {children}
        </Tooltip>
      );
    }
  };
  const [seen1, setseen1] = useState(false);
  const mouseent1 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen1(true);
  };
  const mouseext1 = () => {
    setseen1(false);
  };
  const [seen2, setseen2] = useState(false);
  const mouseent2 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen2(true);
  };
  const mouseext2 = () => {
    setseen2(false);
  };
  const [seen3, setseen3] = useState(false);
  const mouseent3 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen3(true);
  };
  const mouseext3 = () => {
    setseen3(false);
  };
  const [seen4, setseen4] = useState(false);
  const mouseent4 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen4(true);
  };
  const mouseext4 = () => {
    setseen4(false);
  };
  const [seen5, setseen5] = useState(false);
  const mouseent5 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen5(true);
  };
  const mouseext5 = () => {
    setseen5(false);
  };
  const [seen6, setseen6] = useState(false);
  const mouseent6 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen6(true);
  };
  const mouseext6 = () => {
    setseen6(false);
  };
  const [seen7, setseen7] = useState(false);
  const mouseent7 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen7(true);
  };
  const mouseext7 = () => {
    setseen7(false);
  };
  const [seen8, setseen8] = useState(false);
  const mouseent8 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen8(true);
  };
  const mouseext8 = () => {
    setseen8(false);
  };
  const [seen9, setseen9] = useState(false);
  const mouseent9 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen9(true);
  };
  const mouseext9 = () => {
    setseen9(false);
  };
  const [seen10, setseen10] = useState(false);
  const mouseent10 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen10(true);
  };
  const mouseext10 = () => {
    setseen10(false);
  };
  const [seen11, setseen11] = useState(false);
  const mouseent11 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen11(true);
  };
  const mouseext11 = () => {
    setseen11(false);
  };
  const [seen12, setseen12] = useState(false);
  const mouseent12 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen12(true);
  };
  const mouseext12 = () => {
    setseen12(false);
  };
  const [seen13, setseen13] = useState(false);
  const mouseent13 = () => {
    setseen1(false);
    setseen2(false);
    setseen3(false);
    setseen4(false);
    setseen5(false);
    setseen6(false);
    setseen7(false);
    setseen8(false);
    setseen9(false);
    setseen10(false);
    setseen11(false);
    setseen12(false);
    setseen13(false);
    setseen13(true);
  };
  const mouseext13 = () => {
    setseen13(false);
  };
  return (
    <>
      <div className="snap">
        <div className="quiz">
          <div className="quiz_image1"></div>
          <div className="quiz_component" style={{ marginTop: "80px" }}>
            <form class="form_data" style={{ width: "100%" }}>
              <div className="element">
                <h6 className="ques_name">
                  You've made the first version of your product that's good
                  enough to roll out. Will it go live, or would you wait more to
                  make it better?
                </h6>
                {seen1 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Make it live as soon as possible
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Keep the changes for the next release
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Unsure, so may stall the release
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Implement some last minute changes
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Push the release date by 2 weeks and include some BIG
                        changes
                      </div>
                    </div>
                  </div>
                )}
                {!seen1 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q1}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-always"
                    step={1}
                    min={0}
                    max={4}
                    onChange={q1u}
                    marks={optq1}
                    valueLabelDisplay="on"
                    ValueLabelComponent={ValueLabelComponent1}
                    onMouseEnter={mouseent1}
                    onMouseLeave={mouseext1}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  "Not everyone can be a leader". To what degree do you agree
                  with this statement?
                </h6>
                {seen2 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Neutral
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Agree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly agree
                      </div>
                    </div>
                  </div>
                )}
                {!seen2 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q2}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q2u}
                    marks={optq2}
                    ValueLabelComponent={ValueLabelComponent2}
                    onMouseEnter={mouseent2}
                    onMouseLeave={mouseext2}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  Where do you lie on the spectrum between happiness and growth
                  for your company?
                </h6>
                {seen3 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Extremely unlikely
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Somewhat unlikely
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Neutral
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Somewhat likely
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Extremely likely
                      </div>
                    </div>
                  </div>
                )}
                {!seen3 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q3}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-always"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q3u}
                    marks={optq3}
                    ValueLabelComponent={ValueLabelComponent3}
                    onMouseEnter={mouseent3}
                    onMouseLeave={mouseext3}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  It's 2021, fail fast, fail often, and let's make the best
                  product we can. How much do you agree with this statement?
                </h6>
                {seen10 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Neutral
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Agree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly agree
                      </div>
                    </div>
                  </div>
                )}
                {!seen10 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q10}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q10u}
                    marks={optq10}
                    ValueLabelComponent={ValueLabelComponent10}
                    onMouseEnter={mouseent10}
                    onMouseLeave={mouseext10}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  "If it is to be it's up to me". Should one be answerable and
                  take charge, or be more forthcoming to lead from the front?
                </h6>
                {seen11 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        We prefer delegating duties and allow onwers to be
                        accountable
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Being personally accountable comes first
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Leaders need lead from the front and also be the last
                        one standing
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        It's more about allowing everyone to lead
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        We prefer owners to take charge since day one and be
                        forthcoming in their leadership
                      </div>
                    </div>
                  </div>
                )}
                {!seen11 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q11}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q11u}
                    marks={optq11}
                    ValueLabelComponent={ValueLabelComponent11}
                    onMouseEnter={mouseent11}
                    onMouseLeave={mouseext11}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="quiz">
          <div className="quiz_image2"></div>
          <div className="quiz_component" style={{ marginTop: "70px" }}>
            <form className="form_data" style={{ width: "100%" }}>
              <div className="element">
                <h6 className="ques_name">
                  "Personal accountability is of utmost importance". How much do
                  you agree with this?
                </h6>
                {seen4 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Neutral
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Agree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly agree
                      </div>
                    </div>
                  </div>
                )}
                {!seen4 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q4}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q4u}
                    marks={optq4}
                    ValueLabelComponent={ValueLabelComponent4}
                    onMouseEnter={mouseent4}
                    onMouseLeave={mouseext4}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  Great just isn't good enough, there's got to be something we
                  can improve. How much do you agree with this?
                </h6>
                {seen5 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Neutral
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Agree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly agree
                      </div>
                    </div>
                  </div>
                )}
                {!seen5 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q5}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q5u}
                    marks={optq5}
                    ValueLabelComponent={ValueLabelComponent5}
                    onMouseEnter={mouseent5}
                    onMouseLeave={mouseext5}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  The whole is greater than the sum of its parts. How much do
                  you agree with this statement?
                </h6>
                {seen6 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Disagree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Neutral
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Agree
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Strongly agree
                      </div>
                    </div>
                  </div>
                )}
                {!seen6 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q6}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q6u}
                    marks={optq6}
                    ValueLabelComponent={ValueLabelComponent6}
                    onMouseEnter={mouseent6}
                    onMouseLeave={mouseext6}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  Shared goals amongst teams can be difficult to quantify in
                  reviews. Do you lean more towards structured silos or
                  unstructured teams for collaboration?
                </h6>
                {seen12 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Structured silos are best for collaboration
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Silos with some flexibility
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Depending on the need, both are important
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Some structured teams with lots of freedom
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Unstructured teams are best for collaboration
                      </div>
                    </div>
                  </div>
                )}
                {!seen12 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q12}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q12u}
                    marks={optq12}
                    ValueLabelComponent={ValueLabelComponent12}
                    onMouseEnter={mouseent12}
                    onMouseLeave={mouseext12}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="quiz">
          <div className="quiz_image3"></div>
          <div className="quiz_component" style={{ marginTop: "0px" }}>
            <form className="form_data" style={{ width: "100%" }}>
              <div className="element">
                <h6 className="ques_name">
                  How likely are you to change your product if 2 customers flag
                  what they don't like?
                </h6>
                {seen7 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Extremely unlikely
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Somewhat unlikely
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Neutral
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Somewhat likely
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Extremely likely
                      </div>
                    </div>
                  </div>
                )}
                {!seen7 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q7}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q7u}
                    marks={optq7}
                    ValueLabelComponent={ValueLabelComponent7}
                    onMouseEnter={mouseent7}
                    onMouseLeave={mouseext7}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  Do you lean more towards taking your time and learning along
                  the way, or being bold and pushy to reach where you need to
                  go?
                </h6>
                {seen8 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Taking your time and gradually learning as an approach
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        A medium paced cautious approach
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Taking calulative steps is wise
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        A fast paced cautious approach
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Bold and pushy approach
                      </div>
                    </div>
                  </div>
                )}
                {!seen8 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q8}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q8u}
                    marks={optq8}
                    ValueLabelComponent={ValueLabelComponent8}
                    onMouseEnter={mouseent8}
                    onMouseLeave={mouseext8}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  "The customer/user is always right". Do you lean more towards
                  quality of the product or giving users what they want?
                </h6>
                {seen9 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        It's all about the quality
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        User inputs are more like suggestions
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        We listen to users and have a strong hold on quality
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        We listen to our users
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        We give into our users needs easily
                      </div>
                    </div>
                  </div>
                )}
                {!seen9 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q9}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q9u}
                    marks={optq9}
                    ValueLabelComponent={ValueLabelComponent9}
                    onMouseEnter={mouseent9}
                    onMouseLeave={mouseext9}
                  />
                </div>
              </div>
              <div className="element">
                <h6 className="ques_name">
                  When it comes to curiosity do you take a more conservative or
                  aggressive approach?
                </h6>
                {seen13 && window.innerWidth > 550 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "9px",
                      gap: "2px",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginLeft: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Prefer to carefully delve into the unknown
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Only take on as much as we can handle
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Luke warm towards curiosity
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Take on questions as they come
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "20%",
                        alignItems: "center",
                        padding: "0px 2px",
                        justifyContent: "center",
                        // backgroundColor: "#F5FAFF",
                        color: "black",
                        textAlign: "center",
                        marginRight: "-10%",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FAFF",
                          padding: "4px",
                          borderRadius: "3px",
                        }}
                      >
                        Prefer to constantly ask all the questions, now!
                      </div>
                    </div>
                  </div>
                )}
                {!seen13 && window.innerWidth > 550 && (
                  <div style={{ height: "30px" }}></div>
                )}
                <div className="slider">
                  <PrettoSlider1
                    value={q13}
                    defaultValue={0}
                    aria-labelledby="discrete-slider-custom"
                    step={1}
                    max={4}
                    valueLabelDisplay="on"
                    onChange={q13u}
                    marks={optq13}
                    ValueLabelComponent={ValueLabelComponent13}
                    onMouseEnter={mouseent13}
                    onMouseLeave={mouseext13}
                  />
                </div>
              </div>

              <div className="align-center">
                <Button
                  className=""
                  variant="contained"
                  onClick={() =>
                    props.buttonClicked(
                      q1,
                      q2,
                      q3,
                      q4,
                      q5,
                      q6,
                      q7,
                      q8,
                      q9,
                      q10,
                      q11,
                      q12,
                      q13
                    )
                  }
                  style={{
                    width: "300px",
                    backgroundColor: "#2ecc71",
                    color: "white",
                    borderRadius: "30px",
                    textTransform: "none",
                    fontFamily: "Montserrat",
                  }}
                >
                  Check out your core values
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Quiz;
